import { isDevBuild } from 'src/common/utils/environment';

if (isDevBuild()) {
  import('./patchConsoleError');
  import('./patchConsoleWarn');
}
